import React from 'react';
import PropTypes from 'prop-types';
import SwipeableViews from 'react-swipeable-views';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import MidblockLocationDetails from './MidblockLocationDetails';
import MidblockFiles from './MidblockFiles';
import MidblockTrafficCount from './MidblockTrafficCounts';
import Button from '@material-ui/core/Button';
import Cookies from 'js-cookie';
import ExportData from '../../DataFilter/ExportData';

import API_PATH from "../../../constants/config.json";
import { useHistory } from 'react-router-dom';
// import { clearCookie } from '../../../functions/Auth';
const queryString = require('query-string');
const axios = require('axios');
const API_URL = process.env.REACT_APP_BASE_URL;

function TabPanel(props) {

  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography component="div">{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
  };
}

//Start Css Code ...
const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    width: '100%',
    padding: '0px',
    float: 'left',
    marginTop: '-30px',
    '& .Mui-selected': {
      background: '#24618E',
      color: "#fff !important",
      fontWeight: '600',
    },
    '& .MuiTabs-root': {
      minHeight: '35px',
    },
    '& .MuiTabs-flexContainer': {
      display: 'inline-block',
    },
    '& .MuiTabs-indicator': {
      backgroundColor: 'transparent !important',
    },
    '& .MuiTab-root': {
      minWidth: '190px',
    },
    '& .PrivateTabIndicator-colorPrimary-14': {
      backgroundColor: '#24618E',
    },
    '& .MuiAppBar-colorDefault': {
      boxShadow: 'none',
      background: '#fff',
      '& .MuiButtonBase-root': {
        border: '1px solid #24618E',
        borderRadius: '6px 6px 0px 0px',
        minHeight: 'auto',
        borderBottom: 'none',
        color: "#333",
        padding: '5px 10px',
      }
    },
    '& h5': {
      fontSize: '16pt',
      margin: '0px 0 10px',
    }
  },
  mainBlock: {
    padding: '10px',
    position: 'absolute',
    height: '98%',
    width: '100%',
    float: 'left',
    background: '#fff',
    top: '2%',
    zIndex: '1',
    width: '100%',
    '& h4': {
      margin: '0',
      color: '#24618E',
      marginTop: '30px',
      '@media only screen and (max-width: 3500px)': {
        fontSize: '20pt',
      },
      '@media only screen and (min-width: 3501px)': {
        fontSize: '30pt',
      },
    },
    '& .MuiPaper-elevation2': {
      boxShadow: 'none',
    },
    '& .focus': {
      background: '#24618E',
      color: "#fff !important",
      fontWeight: '600',
    },
  },
  tabblock: {
    border: '1px solid #24618E',
    paddingTop: '10px',
    marginBottom: '10px',
    borderRadius: '0px 5px 5px 5px',
    width: '100%',
    float: 'left',
    '& .MuiBox-root': {
      padding: '0px 5px 10px 10px',
    },
    '& .MuiInput-underline:after': {
      borderBottom: 'none !important',
    },
    '& .MuiInput-underline:before': {
      borderBottom: 'none !important',
    }
  },
  innerTabDivFirst: {
    width: '100%',
    float: 'left',   
    overflowX: 'hidden',
    overflowY: 'scroll',
  },
  innerTabDivThird:{
    width: '100%',
    float: 'left',   
    overflowX: 'hidden',
    overflowY: 'scroll',  
  },
  innerTabDivSecond:{
    width: '100%',
    float: 'left',   
    overflowX: 'hidden',
    overflowY: 'hidden', 
  },
  exportButton: {
    border: '1px solid #333',
    color: '#333',
    position: 'relative',
    right: '10px',
    float: 'right',
    top: '-5px',
    zIndex: '9999',
    background: '#fff !important',
    '@media only screen and (max-width: 3500px)': {
      width: '120px',
      fontSize: '14pt',
    },
    '@media only screen and (min-width: 3501px)': {
      width: '160px',
      fontSize: '24pt',
    },
    '&:hover': {
      boxShadow: '4px 3px 3px 0px #999',
    }
  },
  mainExportBlock: {
    position: 'absolute',
    zIndex: '1111',
    width: '100%',
    float: 'left',
    height: '100%',
  },
  tabDisable: {
    backgroundColor: '#ffffff',
    color: '#666666',
    border: '1px solid grey',
    opacity: 0.5,
  },
}));
//End Css Code ...

//Start MidblockDetails component code ...
export default function MidblockDetails(props) {
  let activeMidTab = sessionStorage.getItem('activeMidTab') ? parseInt(sessionStorage.getItem('activeMidTab')) : 0;
  
  let msHeight = window.innerHeight;
  sessionStorage.setItem('midTabHeight', window.innerHeight);
  sessionStorage.setItem('midTabWidth', window.innerWidth);


  // This code is use to get window viewport height
  if (window.screen.width >= 100 && window.screen.width <= 1500) {
    msHeight = window.innerHeight - 200;
    sessionStorage.setItem('midInnerHeight', window.innerHeight - 260);
  }
  else if (window.screen.width >= 1501 && window.screen.width <= 3500) {
    msHeight = window.innerHeight - 210;
    sessionStorage.setItem('midInnerHeight', window.innerHeight - 270);
  }
  else if (window.screen.width >= 3501) {
    msHeight = window.innerHeight - 322;
    sessionStorage.setItem('midInnerHeight', window.innerHeight - 425);
  }
  else {
    msHeight = window.innerHeight - 200;
    sessionStorage.setItem('midInnerHeight', window.innerHeight - 260);
  }
  // This code is use to get window viewport height

  const classes = useStyles();
  const theme = useTheme();
  const [value, setValue] = React.useState(activeMidTab);
  const [ldTab, setLdTab] = React.useState("fo");
  const [tcTab, setTcTab] = React.useState("fo");
  const [fTab, setFTab] = React.useState("fo");
  const [getStation, setGetStation] = React.useState();
  const [exportBlock, setExportBlock] = React.useState(false);
  const [multipleStationId, setMutipleStationId] = React.useState([]);
  const [disableTab, setDisableTab] = React.useState(false);
  const [stationId, setStationId] = React.useState(null);
  const [volumeCountDate, setVolumeCountDate] = React.useState();
  const [volumeClassCountDate, setVolumeClassCountDate] = React.useState();
  const [traffiSpeedCountDate, setTraffiCountDate] = React.useState();
  const [midScreenHeight, setMidScreenHeight] = React.useState(msHeight);
  const [disableTabFiles, setDisableTabFiles] = React.useState(false);

  let history = useHistory();

   // This code is use to change window viewport height
   window.onresize = function () {
    sessionStorage.setItem('midTabHeight', window.innerHeight);
    sessionStorage.setItem('midTabWidth', window.innerWidth);

    if (window.screen.width >= 100 && window.screen.width <= 1500) {
      msHeight = window.innerHeight - 200;
      setMidScreenHeight(msHeight);
      sessionStorage.setItem('midInnerHeight', window.innerHeight - 260);
    }
    else if (window.screen.width >= 1501 && window.screen.width <= 3500) {
      msHeight = window.innerHeight - 210;
      setMidScreenHeight(msHeight);
      sessionStorage.setItem('midInnerHeight', window.innerHeight - 270);
    }
    else if (window.screen.width >= 3501) {
      msHeight = window.innerHeight - 322;
      setMidScreenHeight(msHeight);
      sessionStorage.setItem('midInnerHeight', window.innerHeight - 425);
    }
    else {
      msHeight = window.innerHeight - 200;
      setMidScreenHeight(msHeight);
      sessionStorage.setItem('midInnerHeight', window.innerHeight - 260);
    }
  };
  // This code is use to change window viewport height


  React.useEffect(
    () => {
      if (props.location) {
        const parsed = queryString.parse(props.location.search);
        if (parsed.station) {
          if (sessionStorage.getItem('stationDetails') ){
            if(sessionStorage.getItem('stationDetails') !== parsed.station){
              handleChange(null, 0);
              sessionStorage.setItem('stationDetails', [parsed.station]);
            }
          } else {
            sessionStorage.setItem('stationDetails', [parsed.station]);
          }
          getStationId(parsed.station);
        } else {
          history.push('/UsersDashboard');
        }
      }

      return () => {
        sessionStorage.removeItem('activeMidTab');
        sessionStorage.removeItem('midSelectedDate');
        sessionStorage.removeItem('activeMidTrafficCountTab');
        sessionStorage.removeItem('activeMidSpeedTab');
        sessionStorage.removeItem('activeMidClassTab');
        sessionStorage.removeItem('activeMidVolTab');
        sessionStorage.removeItem('stationDetails');
      };
    }, []
  );

  //This method is use for call station id api for station id .... start
  const getStationId = (id) => {
    try {
      axios({
        method: 'post',
        data: {
          "clientStationId": id
        },
        headers: {
          'payload': Cookies.get('payload'),
          'agencyid': sessionStorage.getItem('agency_id')
        },
        url: API_URL + API_PATH.getStationId
      }).then(function (response) {
        if (response && response.data && response.data.data && response.data.data.length > 0) {
          const stationId = response.data.data[0].station_id;
          setStationId(stationId);
          getStationData(stationId);
          getDateList(stationId);
          getStationRecentYear(stationId);
          getFileList(stationId);
        } else {
          history.push('/UsersDashboard');
        }
      })
    }
    catch (error) {
      //Throw Error
    }
  }
  //This method is use for call station id api for station id .... end

  
  //This method is use for call date api for date list .... start
  const getDateList = (id) => {
    try {
      axios({
        method: 'post',
        data: {
          "stationId": id
        },
        headers: {
          'payload': Cookies.get('payload'),
          'agencyid': sessionStorage.getItem('agency_id')
        },
        url: API_URL + API_PATH.getStationMBCountDateList
      }).then(function (response) {
        if (response && response.data.data && response.data.data.length > 0) {
          let data = response.data.data;
          setDisableTab(data.length > 0 ? false : true);

        } else {
          setDisableTab(true);
        }
      })
    }
    catch (error) {
      //Throw Error
      setDisableTab(true);
    }
  }
  //This method is use for call date api for date list .... end


  //This method is use for call getStationDetail api for station details .... start
  const getStationData = (id) => {
    try {
      axios({
        method: 'get',
        url: API_URL + API_PATH.getStationDetail + id,
      })
        .then(function (response) {
          if (response && response.data.data) {
            let exportStationData = response.data.data;
            setGetStation(response.data.data.client_station_id + ' - ' + response.data.data.station_location);
            setMutipleStationId([{ station_id: exportStationData.station_id, station_type: exportStationData.station_type, client_Station_Id: exportStationData.client_station_id, Station_location: exportStationData.station_location }])
          }
        })
        .catch(function (error) {
          //Throw Error
        })
    } catch (error) {
      console.error(error);
    }
  }
  //This method is use for call getStationDetail api for station details .... end

  const handleChange = (event, newValue) => {
    sessionStorage.setItem('activeMidTab', newValue); //set active tab index in session to retain tab on refresh
    setValue(newValue);
  };

  const handleChangeIndex = (index) => {
    sessionStorage.setItem('activeMidTab', index);//set active tab index in session to retain tab on refresh
    setValue(index);
  };

  const setExportDataBlock = () => {
    setExportBlock((prev) => !prev);
  }

  //This method is use for call getStationRecentYear api for recent year data .... start
  const getStationRecentYear = (id) => {
    try {
      axios({
        method: 'post',
        url: API_URL + API_PATH.getStationRecentYear,
        data: {
          stationId: id
        }
      }).then(function (response) {
        if (response && response.data.data) {
          setVolumeCountDate(response.data.data.volumeyear);
          setVolumeClassCountDate(response.data.data.classyear);
          setTraffiCountDate(response.data.data.speedyear);
        } else {
          //Data Not Found
        }
      })
    }
    catch (error) {
      // Throw Error .. 
    }
  }
  //This method is use for call getStationRecentYear api for recent year data .... end

  const getFileList = (stationId) => {
    try {
      axios({
        method: 'post',
        data: {
          stationId,
          pageNo: 1,
          entriesPerPage: 25
        },
        headers: {
          'payload': Cookies.get('payload'),
          'agencyid': sessionStorage.getItem('agency_id')
        },
        url: API_URL + API_PATH.fileList,
      })
        .then(function (response) {
          if (response && response.data.data) {
            let data = response.data.data;
            setDisableTabFiles(data.count > 0 ? false : true);
          } else {
            setDisableTabFiles(true);
          }
        })
    } catch (error) {
      setDisableTabFiles(true);
    }
  }

  return (
    <React.Fragment>
      <div className={classes.mainBlock}>        
        <h4>Midblock Station Details - {getStation}</h4>
        <hr style={{ marginTop: '0px' }} />
        <p><Button variant="outlined" className={classes.exportButton} onClick={() => setExportDataBlock()} disabled={volumeCountDate || volumeClassCountDate || traffiSpeedCountDate ? false : true}>Export</Button></p>
        <div className={classes.root}>
          <AppBar position="static" color="default" style={{ position: "relative" }}>
            <Tabs
              value={value}
              onChange={handleChange}
              indicatorColor="primary"
              textColor="primary"
              variant="fullWidth"
              aria-label="full width tabs example"
            >
              <Tab label="Location Details" {...a11yProps(0)} className={ldTab} data-testid="midLocationTab" />
              <Tab className={disableTab ? classes.tabDisable : tcTab} label="Traffic Count" data-testid="midTrafficTab" {...a11yProps(1)} disabled={disableTab} />
              {/* <Tab label="Traffic Count" {...a11yProps(1)} className={tcTab} data-testid="midTrafficTab" /> */}
              <Tab className={disableTabFiles ? classes.tabDisable : fTab} label="Files" {...a11yProps(2)} data-testid="midFilesTab" disabled={disableTabFiles} />
            </Tabs>
          </AppBar>
          <SwipeableViews
            axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
            index={value}
            onChangeIndex={handleChangeIndex}
          >
            <TabPanel value={value} index={0} dir={theme.direction} className={classes.tabblock}>
              <div className={classes.innerTabDivFirst} style={{ height: midScreenHeight.toString() + 'px' }}>
                <MidblockLocationDetails stationId={stationId} />
              </div>
            </TabPanel>
            <TabPanel value={value} index={1} dir={theme.direction} className={classes.tabblock}>
            <div className={classes.innerTabDivSecond} style={{ height: midScreenHeight.toString() + 'px' }}>
              <MidblockTrafficCount stationId={stationId} />
            </div>
            </TabPanel>
            <TabPanel value={value} index={2} dir={theme.direction} className={classes.tabblock}>
              <div className={classes.innerTabDivThird} style={{ height: midScreenHeight.toString() + 'px' }}>
                <MidblockFiles stationId={stationId} />
              </div>
            </TabPanel>
          </SwipeableViews>
        </div>
      </div>
      {exportBlock == true ?
        <div className={classes.mainExportBlock}>
          <ExportData checkExportValue={setExportDataBlock} groupStations={multipleStationId} />
        </div> : null}
    </React.Fragment>
  );
}
//End MidblockDetails component code ...